<template>
  <div class="min-h-screen flex flex-col">
    <FlashMessage />
    <slot />
  </div>
</template>

<script setup>
import { FlashMessage } from '@/components/ui/flash-message'
</script>
